import * as React from 'react';
import { useParams } from 'react-router';
import { Page } from '../../subs/Page';
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Box, Button, Collapse, IconButton } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Tooltip, Typography, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { AlertProps } from '@mui/material/Alert';
import { Link as LinkRouter } from 'react-router-dom';

import AddBoxIcon from '@mui/icons-material/AddBox';

import { httpGet } from '../../Web';
import { WorkshopUser, WorkshopUserStatus, getWorkshopUsers } from '../../types/WorkshopUser';

import { TestCombinationInterfaces, gettestcombinationinterfaceslist } from '../../types/TestCombinations';
import { WorkshopProductCombination, getWSProductCombinations } from '../../types/WorkshopProductCombination';

import TaskAlt from '@mui/icons-material/TaskAlt';
import CancelRounded from '@mui/icons-material/CancelRounded';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { WorkshopInterface } from '../../types/WorkshopInterface';
import { Interface } from '../../types/Interface';
import { WorkshopProduct, getWorkshopProducts } from '../../types/WorkshopProducts';
import { Product } from '../../types/Product';
import { matchLeft, unique } from '../../Utils';
import { PageSection } from '../../subs/PageSection';
import { SuccessFailureIndicator } from '../../subs/SuccessFailureIndicator';
import { RemoveWorkshopProductModal } from '../../modals/RemoveWorkshopProduct';
import { UpdateWsProductForm2, AddProductToWorkshopLocalModal } from '../../modals/AddProductToWorkshopModal';
import { WorkshopProductInterface } from '../../types/WorkshopProductInterface';
import { Workshop, WorkshopStatus, getWorkshop, getWorkshopInterfaces } from '../../types/Workshop';
import { UserContext } from '../../UserProvider';
import { getUserWorkshops, isGlobalAdmin, getUser } from '../../types/User';
import { useSnackbar } from '../../../contexts/SnackBarContext';

const PageHeader = ({ workshopId, isWSUser, workshopProducts, setWorkshopProducts, productInterfaces, setProductInterfaces }:
    {
        workshopId: string, isWSUser: boolean,
        workshopProducts: WorkshopProduct[],
        setWorkshopProducts: React.Dispatch<React.SetStateAction<WorkshopProduct[]>>,
        productInterfaces: WorkshopProductInterface[],
        setProductInterfaces: React.Dispatch<React.SetStateAction<WorkshopProductInterface[]>>,
    }) => {
    // const pageLocation = useLocation();
    const [addModalOpenState, setAddModalOpenState] = React.useState<boolean>(false);

    return <>
        <AddProductToWorkshopLocalModal workshopID={Number(workshopId)} workshopProducts={workshopProducts}
            setWorkshopProducts={setWorkshopProducts} openState={addModalOpenState} setOpenState={setAddModalOpenState}
            workshopProductsInterfaces={productInterfaces} setWorkshopProductInterfaces={setProductInterfaces} />

        <Stack direction={'row'} justifyContent={'space-between'}>
            <Typography variant='h4'>{'List of registered users and Products'}</Typography>
            <Stack direction={'row'} columnGap={5}>
                <Button disabled={!isWSUser} startIcon={<AddBoxIcon />}
                    onClick={() => { setAddModalOpenState(true); }}>
                    {'Add Product'}
                </Button>
            </Stack>
        </Stack></>
}

function SupportIcon(props: { title: string, supported: boolean | null }) {

    const getIcon = () => {
        if (props.supported === true) return <TaskAlt fontSize="small" color="success" />;
        if (props.supported === false) return <CancelRounded fontSize="small" color="disabled" />;
        return <CancelRounded fontSize="small" color="disabled" />;
    };

    return (
        <Stack flexDirection='row' justifyContent='space-between' alignItems='center' >
            <Typography variant='body2' >{props.title}</Typography>
            <Box
                sx={{
                    display: 'inline-flex',
                    align: 'center',
                    justifyContent: 'center',
                    paddingLeft: '4px',
                    height: "100%"
                }}
            >
                {getIcon()}
            </Box>
        </ Stack>
    );
}

const WsProductInterfaceTable = ({ workshopUser, products, workshopData, workshopProducts, setWorkshopProducts,
    testCombinationInterfaces, workshopProductCombinations, interfaces, productInterfaces, setProductInterfaces }:
    {
        workshopUser: WorkshopUser, products: Product[], workshopProducts: WorkshopProduct[],
        setWorkshopProducts: React.Dispatch<React.SetStateAction<WorkshopProduct[]>>,
        workshopData: Workshop | undefined,
        testCombinationInterfaces: TestCombinationInterfaces[], workshopProductCombinations: WorkshopProductCombination[],
        interfaces: Interface[], productInterfaces: WorkshopProductInterface[],
        setProductInterfaces: React.Dispatch<React.SetStateAction<WorkshopProductInterface[]>>,
    }) => {
    const { showSnackbar } = useSnackbar();

    const [wpIdselected, setWpIdSelected] = React.useState<number>(-1);
    const [expandedNode, setExpandedNode] = React.useState<number>(0);
    const [deleteModalOpenState, setDeleteModalOpenState] = React.useState<boolean>(false);
    const [editWorkshopProductModalOpenState, setEditWorkshopProductModalOpenState] = React.useState<boolean>(false);
    const userContext = React.useContext(UserContext);
    const [userProducts, setUserProducts] = React.useState<[Product, WorkshopProduct][]>([]);
    const [userRights, setuserRights] = React.useState<number>(0);

    React.useEffect(() => {
        setUserProducts(matchLeft(products, workshopProducts, (left: Product, right: WorkshopProduct) => left.id === right.productId)
            .filter(([product, workshopProducts]) => product.companyId === workshopUser.companyId)
            .flatMap(([product, workshopProducts]) => workshopProducts.map(wp => [product, wp] as [Product, WorkshopProduct])));

    }, [workshopProducts, products, productInterfaces, workshopUser]);

    const showUserFeedback = React.useCallback((msg: string, severity: AlertProps['severity'] = 'error') => {
        showSnackbar(msg, severity);
    }, [showSnackbar]);

    React.useEffect(() => {
        const fetch = async () => {
            try {
                const userContextData = await getUser(userContext.user.id!!, new AbortController());

                if (userContextData) {
                    setuserRights(userContextData.result.accessLevel ? userContextData.result.accessLevel : 0);
                    return;
                }
            } catch (error) {
                showUserFeedback(String(error), "error");
            }
        }
        fetch();
    }, [userContext, showUserFeedback])

    let rowEven = false;

    return <>
        <RemoveWorkshopProductModal setWorkshopProducts={setWorkshopProducts} workshopProducts={workshopProducts} openState={deleteModalOpenState}
            setOpenState={(state) => setDeleteModalOpenState(state)} wpId={wpIdselected} />

        <UpdateWsProductForm2 wpId={wpIdselected} workshopProducts={workshopProducts} setWorkshopProducts={setWorkshopProducts}
            openState={editWorkshopProductModalOpenState} setOpenState={setEditWorkshopProductModalOpenState}
            workshopProductsInterfaces={productInterfaces} setWorkshopProductInterfaces={setProductInterfaces} />
        {userProducts && userProducts.map(([product, workshopProduct], index) =>
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <Accordion expanded={expandedNode === workshopProduct.id} sx={{ width: '98%' }}
                    onChange={() => setExpandedNode(expandedNode === workshopProduct.id ? -1 : workshopProduct.id)}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Stack width={'100%'} direction={'row'} justifyContent={'space-between'} alignItems='center'>
                            <Typography variant='subtitle1'>{`${product.name} (Version: ${workshopProduct.productVersion})`}</Typography>
                            <Box>
                                <Tooltip title={'This allows specifying the supported OPC UA features in more detail and provide additional information about the product like EndpointUrls or username/password combinations.'}>
                                    <IconButton aria-label="Configure" disabled={workshopData?.status === WorkshopStatus.Registration ? false : workshopData?.status === WorkshopStatus.Testing ? false : true}
                                        component={LinkRouter} to={`/WSTesting/${workshopData?.id}`} >
                                        <SettingsIcon />
                                    </IconButton>
                                </Tooltip>,
                                <Tooltip title={'This opens the testing screen to allow entering testing results for the event.'}>
                                    <IconButton aria-label="Start Testing" disabled={workshopData?.status === WorkshopStatus.Testing ? false : true}
                                        component={LinkRouter} to={`/wstestingrecords/${workshopData?.id}`} >
                                        <PlaylistAddCheckCircleIcon />
                                    </IconButton>
                                </Tooltip>,
                                <Tooltip title={'Edit the product definitions like product name and supported interfaces like OPC UA Client/Server, PubSub, UAFX and others.'}>
                                    <IconButton aria-label="Edit Product" disabled={userRights === 0 ? true : false}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setWpIdSelected(workshopProduct.id); setEditWorkshopProductModalOpenState(true);
                                        }} >
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>,
                                <Tooltip title={'Delete this Product and all of its settings from the Workshop.'}>
                                    <IconButton aria-label="Delete Product" disabled={userRights === 0 ? true : false}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setWpIdSelected(workshopProduct.id); setDeleteModalOpenState(true);
                                        }}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Stack>
                    </AccordionSummary>

                    <AccordionDetails>
                        <Grid container rowGap={5} columnSpacing={0}
                            sx={{
                                "--Grid-borderWidth": "1px",
                                border: "var(--Grid-borderWidth) solid",
                                borderColor: "divider",
                                "& > div": {
                                    borderColor: "divider",
                                },
                            }}>
                            <Grid size={{ xs: 3 }} borderBottom={1}>
                                <Typography variant='bold'>{"Feature"}</Typography>
                            </Grid>
                            <Grid size={{ xs: 3 }} borderBottom={1}>
                                <Typography variant='bold'>{"Provider"}</Typography>
                            </Grid>
                            <Grid size={{ xs: 3 }} borderBottom={1}>
                                <Typography variant='bold'>{"Consumer"}</Typography>
                            </Grid>
                            <Grid size={{ xs: 3 }} borderBottom={1}>
                                <Typography variant='bold'>{"Interfaces"}</Typography>
                            </Grid>
                            {testCombinationInterfaces && testCombinationInterfaces.map(tci =>
                                tci.interfaces.length > 0 &&
                                <React.Fragment>
                                        <Grid size={{ xs: 3 }} bgcolor={rowEven ? 'var(--Grid-evenBg)' : 'var(--Grid-oddBg)'} >
                                        <Typography variant='body2'>{tci.testCombination.combinationName}</Typography>
                                    </Grid>
                                        <Grid size={{ xs: 2 }} bgcolor={rowEven ? 'var(--Grid-evenBg)' : 'var(--Grid-oddBg)'}>
                                        <SupportIcon title={tci.testCombination.combinationProvider ?? "Provider" }
                                                supported={workshopProductCombinations.find(wpc => wpc.testCombinationId === tci.testCombination.id
                                                    && workshopProduct.id === wpc.workshopProductId)?.isProvider ?? null} />
                                    </Grid>
                                        <Grid size={{ xs: 1 }} bgcolor={rowEven ? 'var(--Grid-evenBg)' : 'var(--Grid-oddBg)'} />
                                        <Grid size={{ xs: 2 }} bgcolor={rowEven ? 'var(--Grid-evenBg)' : 'var(--Grid-oddBg)'}>
                                        <SupportIcon title={tci.testCombination.combinationConsumer ?? "Consumer" }
                                            supported={workshopProductCombinations.find(wpc => wpc.testCombinationId === tci.testCombination.id
                                                && workshopProduct.id === wpc.workshopProductId)?.isConsumer ?? null} />
                                    </Grid>
                                        <Grid size={{ xs: 1 }} bgcolor={rowEven ? 'var(--Grid-evenBg)' : 'var(--Grid-oddBg)'} />
                                    {tci.interfaces.map(( i, index ) =>
                                        <React.Fragment>
                                            {index > 0 && <Grid size={{ xs: 9 }} bgcolor={rowEven ? 'var(--Grid-evenBg)' : 'var(--Grid-oddBg)'} />}
                                            <Grid size={{ xs: 3 }} bgcolor={rowEven ? 'var(--Grid-evenBg)' : 'var(--Grid-oddBg)'} >
                                                <SupportIcon title={i.shortName} supported={productInterfaces.find(pi => pi.interfaceId === i.id
                                                && workshopProduct.id === pi.workshopProductId)?.supportedByProduct ?? null} />
                                            </Grid>
                                            {rowEven = !rowEven}
                                        </React.Fragment>
                                        )}
                                </React.Fragment>
                            )}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Box>
        )}
    </>
}

const UserTableRow = ({ workshopData, workshopUser, products, workshopProducts, setWorkshopProducts, testCombinationInterfaces, workshopProductCombinations, interfaces, productInterfaces, setProductInterfaces }:
    {
        workshopData: Workshop | undefined, workshopUser: WorkshopUser, products: Product[], workshopProducts: WorkshopProduct[],
        setWorkshopProducts: React.Dispatch<React.SetStateAction<WorkshopProduct[]>>,
        testCombinationInterfaces: TestCombinationInterfaces[], workshopProductCombinations: WorkshopProductCombination[],
        interfaces: Interface[], productInterfaces: WorkshopProductInterface[],
        setProductInterfaces: React.Dispatch<React.SetStateAction<WorkshopProductInterface[]>>
    }) => {
    const [open, setOpen] = React.useState<boolean>(false);
    const [firstName, ...lastName] = workshopUser.name?.split(' ') ?? '';

    return <><TableRow hover={true}><TableCell><Typography variant='bold'>{`${lastName.join(' ')}, ${firstName}`}</Typography></TableCell>
        <TableCell>{workshopUser.companyName}</TableCell>
        <TableCell>{<SuccessFailureIndicator success={workshopUser?.status === WorkshopUserStatus.Paid} />}</TableCell>
        <TableCell>{<SuccessFailureIndicator success={workshopUser?.status!! >= WorkshopUserStatus.Registered} />}</TableCell>
        <TableCell>{<IconButton onClick={() => setOpen(!open)}>{!open ? <ExpandMoreIcon /> : <ExpandLessIcon />}</IconButton>}</TableCell>
    </TableRow>
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                <Collapse in={open} timeout={'auto'} unmountOnExit>
                    <WsProductInterfaceTable workshopUser={workshopUser} products={products} workshopProducts={workshopProducts} setWorkshopProducts={setWorkshopProducts}
                        interfaces={interfaces} productInterfaces={productInterfaces} workshopData={workshopData}
                        testCombinationInterfaces={testCombinationInterfaces} workshopProductCombinations={workshopProductCombinations}
                        setProductInterfaces={setProductInterfaces} />
                </Collapse>
            </TableCell>
        </TableRow></>
}

export const ListOfRegisteredUserProducts = () => {
    const { id } = useParams();
    const userContext = React.useContext(UserContext);
    const { showSnackbar } = useSnackbar();

    const [workshopData, setWorkshopData] = React.useState<Workshop>();
    const [workshopUsers, setWorkshopUsers] = React.useState<WorkshopUser[]>([]);
    const [products, setProducts] = React.useState<Product[]>([]);
    const [testCombinationInterfaces, setTestCombinationInterfaces] = React.useState<TestCombinationInterfaces[]>([]);
    const [workshopProductCombinations, setWorkshopProductCombinations] = React.useState<WorkshopProductCombination[]>([]);

    const [workshopInterfaces, setWorkshopInterfaces] = React.useState<WorkshopInterface[]>([]);
    const [workshopProducts, setWorkshopProducts] = React.useState<WorkshopProduct[]>([]);
    const [interfaces, setInterfaces] = React.useState<Interface[]>([]);
    const [productInterfaces, setProductInterfaces] = React.useState<WorkshopProductInterface[]>([]);
    const [singleUser, setSingleUser] = React.useState<WorkshopUser>();
    const [userIsAdmin, setUserIsAdmin] = React.useState<boolean>(false);
    const [isWSUser, setIsWSUser] = React.useState<boolean>(false);

    const showUserFeedback = React.useCallback((msg: string, severity: AlertProps['severity'] = 'error') => {
        showSnackbar(msg, severity);
    }, [showSnackbar]);

    React.useEffect(() => {
        const fetch = async () => {
            try {
                if (Number(id) > 0) {
                    const workshopDataResponse = await getWorkshop(Number(id), new AbortController());

                    if (workshopDataResponse.failed) {
                        showUserFeedback(workshopDataResponse.errorText!!);
                        return;
                    }

                    setWorkshopData(workshopDataResponse.result);
                }

                const globalAdminResponse = await isGlobalAdmin(userContext.user.id!!, new AbortController());

                if (globalAdminResponse) {
                    setUserIsAdmin(true);
                    return;
                }

                const workshopAdminResponse = await getUserWorkshops(userContext.user.id!!, new AbortController());

                if (workshopAdminResponse.failed) {
                    showUserFeedback(workshopAdminResponse.errorText!!);
                    return;
                }

                const userIsAdmin = typeof workshopAdminResponse.result.find(wu => wu.isWorkshopAdmin) !== 'undefined'
                const isWSUser = typeof workshopAdminResponse.result.find(wu => wu.workshopId === Number(id)) !== 'undefined'
                setUserIsAdmin(userIsAdmin);
                setIsWSUser(isWSUser);
            } catch (error) {
                showUserFeedback(String(error));
            }
        }
        fetch();
    }, [userContext, id, showUserFeedback])

    React.useEffect(() => {
        const fetch = async () => {
            try {
                let workshopUsersRequest = await getWorkshopUsers(Number(id), new AbortController());

                if (workshopUsersRequest.failed) {
                    showUserFeedback(workshopUsersRequest.errorText!!);
                    return;
                }

                setWorkshopUsers(workshopUsersRequest.result);
                if (!userIsAdmin) {
                    console.log('userIsAdmin: ', userIsAdmin);
                    setSingleUser(workshopUsersRequest.result.find(wu => wu.userId === userContext.user.id));
                }
            } catch (error) {
                showUserFeedback(String(error));
            }
        }
        fetch();
    }, [userContext, userIsAdmin, id, showUserFeedback]);

    React.useEffect(() => {
        const fetch = async () => {
            try {
                let workshopInterfacesRequest = await getWorkshopInterfaces(Number(id), new AbortController());
                let testCombinationInterfacesRequest = await gettestcombinationinterfaceslist(new AbortController());

                if (workshopInterfacesRequest.failed) {
                    showUserFeedback(workshopInterfacesRequest.errorText!!);
                    return;
                }

                setWorkshopInterfaces(workshopInterfacesRequest.result);

                if (testCombinationInterfacesRequest.failed) {
                    showUserFeedback(testCombinationInterfacesRequest.errorText!!);
                    return;
                }

                const testCombinationInterfacesResults = testCombinationInterfacesRequest.result;
                let filteredTestCombinationInterfaces: TestCombinationInterfaces[] = [];

                testCombinationInterfacesResults.forEach(tci => {
                    const filteredInterfaces = tci.interfaces.filter(i => workshopInterfacesRequest.result.some(wi => wi.interfaceId === i.id));
                    if (filteredInterfaces.length > 0) {
                        filteredTestCombinationInterfaces.push({ ...tci, interfaces: filteredInterfaces });
                    }
                });

                setTestCombinationInterfaces(filteredTestCombinationInterfaces);

            } catch (error) {
                showUserFeedback(String(error));
            }
        }
        fetch();
    }, [id, showUserFeedback]);

    React.useEffect(() => {
        const fetch = async () => {
            if (Number(id) === 0) return;
            try {
                let workshopProductCombinationsRequest = await getWSProductCombinations(Number(id), new AbortController());

                if (workshopProductCombinationsRequest.failed) {
                    showUserFeedback(workshopProductCombinationsRequest.errorText!!);
                    return;
                }

                setWorkshopProductCombinations(workshopProductCombinationsRequest.result);
            } catch (error) {
                showUserFeedback(String(error));
            }
        }
        fetch();
    }, [id, workshopProducts, showUserFeedback]);

    React.useEffect(() => {
        const fetch = async () => {
            try {
                let workshopProductsRequest = await getWorkshopProducts(Number(id), new AbortController());

                if (workshopProductsRequest.failed) {
                    showUserFeedback(workshopProductsRequest.errorText!!);
                    return;
                }

                setWorkshopProducts(workshopProductsRequest.result);
            } catch (error) {
                showUserFeedback(String(error));
            }
        }
        fetch();
    }, [id, showUserFeedback]);

    React.useEffect(() => {
        httpGet('/api/interface', new AbortController())
            .then(requestResult => setInterfaces(requestResult.result.filter((iface: Interface) => workshopInterfaces.find(wi => wi.interfaceId === iface.id))));
    }, [workshopInterfaces]);

    React.useEffect(() => {
        function getProducts(workshopProducts: WorkshopProduct[]) {
            let requestResults: Array<Promise<Product>> = []

            workshopProducts.map(wp => requestResults.push(httpGet(`/api/product/get/${wp.productId}`, new AbortController())));

            Promise.all(requestResults).then(requestResult => setProducts(unique(requestResult.map((productResult: any) => productResult.result), (p1, p2) => p1.id - p2.id)))
        }
        getProducts(workshopProducts);
    }, [workshopProducts]);

    React.useEffect(() => {
        function getProductInterfaces(workshopProducts: WorkshopProduct[]) {
            let requestResults: Array<Promise<WorkshopProductInterface>> = [];

            workshopProducts.map(wp => requestResults.push(httpGet(`/api/workshopproduct/interface/${wp.id}`, new AbortController())));

            Promise.all(requestResults).then(requestResult => setProductInterfaces(requestResult.flatMap((pi: any) => pi.result)))
        }

        getProductInterfaces(workshopProducts);
    }, [workshopProducts]);
 
    return <Page backButton 
        heading={<PageHeader workshopId={id as string}
        isWSUser={isWSUser || userIsAdmin}
        workshopProducts={workshopProducts}
        setWorkshopProducts={setWorkshopProducts}
            productInterfaces={productInterfaces}
            setProductInterfaces={setProductInterfaces} />}>
        {[
            <PageSection>
                {[(userIsAdmin) ?
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{'Last name, first name'}</TableCell>
                                    <TableCell>{'Company'}</TableCell>
                                    <TableCell>{'Confirmed'}</TableCell>
                                    <TableCell>{'Registered'}</TableCell>
                                    <TableCell>{''}</TableCell>
                                </TableRow>
                            </TableHead>

                            {workshopUsers.length > 0 && <TableBody className='alternatingBody'>
                                {workshopUsers.map((tableRow, index) => <UserTableRow workshopUser={tableRow}
                                    workshopData={workshopData}
                                    testCombinationInterfaces={testCombinationInterfaces}
                                    workshopProductCombinations={workshopProductCombinations}
                                    products={products}
                                    workshopProducts={workshopProducts}
                                    setWorkshopProducts={setWorkshopProducts}
                                    interfaces={interfaces}
                                    productInterfaces={productInterfaces}
                                    setProductInterfaces={setProductInterfaces} />)}
                            </TableBody>}

                        </Table>
                    </TableContainer>
                    : singleUser ? <WsProductInterfaceTable workshopUser={singleUser} products={products} workshopProducts={workshopProducts} setWorkshopProducts={setWorkshopProducts}
                        interfaces={interfaces} productInterfaces={productInterfaces} workshopData={workshopData}
                        testCombinationInterfaces={testCombinationInterfaces} workshopProductCombinations={workshopProductCombinations}
                        setProductInterfaces={setProductInterfaces} />
                    : "You are not a user in this workshop"
                ]}
            </PageSection>
        ]}
    </Page>
}

